import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { FrameFilters } from '@/shared/types/domain.types';

interface FilterState {
  filters: FrameFilters;
  setFilters: (filters: Partial<FrameFilters>) => void;
  clearFilters: () => void;
}

const defaultFilters: FrameFilters = {
  location_ids: [],
  manufacturer_ids: [],
  status: undefined,
  order_type: undefined,
  date_from: undefined,
  date_to: undefined,
  search: undefined,
};

export const useFilterStore = create<FilterState>()(
  persist(
    (set) => ({
      filters: defaultFilters,

      setFilters: (newFilters) =>
        set((state) => ({ filters: { ...state.filters, ...newFilters } })),

      clearFilters: () => set({ filters: defaultFilters }),
    }),
    {
      name: 'filter-storage',
    }
  )
);
